module.exports = __webpack_public_path__ + "img/farmstead-hero.19b047c1.jpg";